import { createContext, useState, ReactNode } from 'react';

export type MenuData = {
  selected: number;
};

type MenuContextType = {
  setOption: (n: number) => void;
  getOption: () => number;
};

type MenuProviderProps = {
  children: ReactNode;
};

const MenuContext = createContext<MenuContextType | undefined>(undefined);

const MenuProvider = ({ children }: MenuProviderProps) => {
  const [menu, setMenu] = useState<MenuData>({ selected: 1 });

  const setOption = (selected: number) => {
    const menuSelected = { selected: selected };
    setMenu(menuSelected);
  };

  const getOption = () => {
    return menu.selected;
  };

  return (
    <MenuContext.Provider
      value={{
        setOption: setOption,
        getOption: getOption,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export { MenuContext, MenuProvider };
